module.exports = __webpack_public_path__ + "static/media/file.f7d76c7d.svg";